import { useEffect, useState } from 'react';

/**
 * Hook that provides reactive job name state that updates only on storage events.
 * Does NOT read from localStorage on mount - only updates when storage changes.
 *
 * @param key - The storage key to listen to (e.g., 'draft.job.siteId:date')
 * @returns The current job name from storage, or empty string if not set
 */
export function useJobNameSync(key: string | null) {
  const [jobName, setJobName] = useState<string>('');

  useEffect(() => {
    if (!key) {
      setJobName('');
      return;
    }

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === key) {
        setJobName(e.newValue || '');
      }
    };

    const handleCustomChange = (e: CustomEvent) => {
      if (e.detail.key === key) {
        setJobName(e.detail.value || '');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener(
      'jobNameStorageChanged',
      handleCustomChange as EventListener
    );

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener(
        'jobNameStorageChanged',
        handleCustomChange as EventListener
      );
    };
  }, [key]);

  return jobName;
}
